import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@hooks/useTheme";
import { setLogoutInProgress } from "@auth/keycloakClient";
import { logout } from "@utils/auth";

const Logout = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const [isLoggingOut, setIsLoggingOut] = useState(true);

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout(false, { clearIndexedDb: true });
      } catch (error) {
        console.error("Logout error:", error);
      } finally {
        setLogoutInProgress(false);
        setIsLoggingOut(false);
      }
    };

    performLogout();
  }, []);

  if (isLoggingOut) {
    return (
      <div data-testid="logout-page" className={`min-h-full flex items-center justify-center ${colors.bgSecondary}`}>
        <div className="text-center">
          <div
            className={`mx-auto h-12 w-12 animate-spin rounded-full border-2 ${colors.spinnerBorder}`}
            aria-hidden
          />
          <p className={`mt-4 text-sm ${colors.textSecondary}`}>{t("common.signing-out")}</p>
        </div>
      </div>
    );
  }

  return null;
};

export default Logout;
